"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _throttle = _interopRequireDefault(require("lodash/throttle"));

var _reactEventListener = _interopRequireDefault(require("react-event-listener"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Drawer = _interopRequireDefault(require("@material-ui/core/Drawer"));

var _SwipeableDrawer = _interopRequireDefault(require("@material-ui/core/SwipeableDrawer"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));

/* eslint-disable react/no-danger */
// import { textToHash } from '@material-ui/docs/MarkdownElement/MarkdownElement';
var itemsServer = null; // renderer.heading = (text, level) => {
//   if (level === 1 || level > 3) {
//     return;
//   }
//   if (level === 2) {
//     itemsServer.push({
//       text,
//       level,
//       hash: textToHash(text),
//       children: [],
//     });
//   }
//   if (level === 3) {
//     itemsServer[itemsServer.length - 1].children.push({
//       text,
//       level,
//       hash: textToHash(text),
//     });
//   }
// };

var drawerWidth = 200;

var styles = function styles(theme) {
  var _root;

  return {
    root: (_root = {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontWeight: 400,
      fontSize: '.7rem',
      top: 40,
      width: 200,
      flexShrink: 0,
      order: 2,
      position: 'sticky',
      wordBreak: 'break-word',
      height: 'calc(100vh)',
      overflowY: 'auto',
      padding: "".concat(theme.spacing.unit * 2, "px ").concat(theme.spacing.unit * 1, "px ").concat(theme.spacing.unit * 2, "px ").concat(theme.spacing.unit * 1, "px"),
      display: 'none'
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.up('sm'), {
      display: 'block'
    }), (0, _defineProperty2.default)(_root, '& a', {
      // Style taken from the Link component
      color: theme.palette.text.secondary,
      padding: "".concat(theme.spacing.unit / 2, "px 0"),
      textDecoration: 'none',
      '&:hover': {
        textDecoration: 'underline'
      }
    }), (0, _defineProperty2.default)(_root, '& ul', {
      padding: 0,
      margin: 0,
      listStyleType: 'none'
    }), _root),
    title: {
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.secondary,
      fontWeight: 500,
      fontSize: '.8rem',
      marginTop: theme.spacing.unit * 7,
      borderBottom: '1px solid #eee'
    },
    drawer: {
      width: drawerWidth,
      flexShrink: 0
    },
    drawerPaper: {
      width: drawerWidth
    },
    toolbar: theme.mixins.toolbar,
    content: {
      flexGrow: 1
    }
  };
};

var _ref = _react.default.createElement("p", {
  className: "toc-menu"
}, _react.default.createElement("a", {
  className: "expand-toggle",
  href: "#"
}, "Collapse all"), _react.default.createElement("a", {
  className: "back-to-top",
  href: "#"
}, "Back to top"), _react.default.createElement("a", {
  className: "go-to-bottom",
  href: "#"
}, "Go to bottom"));

var AppTableOfContents =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AppTableOfContents, _React$Component);

  // Corresponds to 10 frames at 60 Hz.
  function AppTableOfContents(props) {
    var _this;

    (0, _classCallCheck2.default)(this, AppTableOfContents);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppTableOfContents).call(this, props));
    _this.handleScroll = (0, _throttle.default)(function () {
      _this.findActiveIndex();
    }, 166);
    _this.state = {
      active: null
    };

    _this.findActiveIndex = function () {
      var active;

      for (var i = 0; i < _this.itemsClient.length; i += 1) {
        var item = _this.itemsClient[i];

        if (document.documentElement.scrollTop < item.node.offsetTop + 100 || i === _this.itemsClient.length - 1) {
          active = item;
          break;
        }
      }

      if (active && _this.state.active !== active.hash) {
        _this.setState({
          active: active.hash
        });
      }
    };

    itemsServer = [];
    return _this;
  }

  (0, _createClass2.default)(AppTableOfContents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.itemsClient = [];
      itemsServer.forEach(function (item2) {
        _this2.itemsClient.push((0, _extends2.default)({}, item2, {
          node: document.getElementById(item2.hash)
        }));

        if (item2.children.length > 0) {
          item2.children.forEach(function (item3) {
            _this2.itemsClient.push((0, _extends2.default)({}, item3, {
              node: document.getElementById(item3.hash)
            }));
          });
        }
      });
      this.findActiveIndex();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleScroll.cancel();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          title = _this$props.title,
          toc = _this$props.toc,
          className = _this$props.className,
          disablePermanent = _this$props.disablePermanent;
      var active = this.state.active;
      return _react.default.createElement("nav", {
        className: classes.root
      }, _react.default.createElement(_Hidden.default, {
        lgUp: !disablePermanent,
        implementation: "js"
      }, _react.default.createElement(_Drawer.default, {
        classes: {
          paper: (0, _classnames.default)(classes.paper, 'algolia-drawer')
        },
        variant: "permanent",
        open: true,
        anchor: "right",
        ModalProps: {
          keepMounted: true
        }
      }, _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_Typography.default, {
        variant: "body2",
        gutterBottom: true,
        className: classes.title
      }, title), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onScroll: this.handleScroll
      }), _react.default.createElement("div", {
        className: classes.content,
        dangerouslySetInnerHTML: {
          __html: toc ? toc : ''
        }
      }), _ref))), disablePermanent ? null : _react.default.createElement(_Hidden.default, {
        mdDown: true,
        implementation: "css"
      }, _react.default.createElement(_Drawer.default, {
        classes: {
          paper: classes.paper
        },
        variant: "permanent",
        open: true,
        anchor: "right"
      }, _react.default.createElement("div", {
        className: classes.root
      }, _react.default.createElement(_Typography.default, {
        variant: "body2",
        gutterBottom: true,
        className: classes.title
      }, title), _react.default.createElement(_reactEventListener.default, {
        target: "window",
        onScroll: this.handleScroll
      }), _react.default.createElement("div", {
        className: classes.content,
        dangerouslySetInnerHTML: {
          __html: toc ? toc : ''
        }
      })))));
    }
  }]);
  return AppTableOfContents;
}(_react.default.Component);

AppTableOfContents.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes.default.object.isRequired,
  toc: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired
} : {};

var _default = (0, _styles.withStyles)(styles)(AppTableOfContents);

exports.default = _default;